import React from 'react';
import TooltipInfo from '../../common/docs/TooltipInfo';
import {
  DS_AIRTABLE,
  DS_DATABASE,
  DS_EXTERNAL_API,
  DS_FIREBASE_CLOUD_FIRESTOE,
  DS_FIREBASE_FUNCTION,
  DS_FIREBASE_REALTIME_DATABASE,
  DS_GOOGLE_SHEET,
  DS_REST_API,
  GET_ITEM_ID_FROM_API,
} from '../../common/utils/event_constants';
import {
  AIRTABLE,
  DATABASE,
  FIREBASE_CLOUD_FIRESTORE,
  FIREBASE_FUNCTION,
  FIREBASE_REALTIME_DATABASE,
  GOOGLE_SHEET,
  REST_API,
} from 'drapcode-constant';

export const CUSTOM_MODAL_SEPARATOR = '!@#$#@!';

export const getDirectionLinkText = (args) => {
  let labelText = '';
  switch (args.optionsType) {
    case 'pageApi':
      labelText = 'Create Page';
      break;
    case 'refreshPageApi':
    case 'showComponentPageApi':
    case 'hideComponentPageApi':
      labelText = 'Create Page';
      break;
    case 'userRoleApi':
      labelText = 'Create Role';
      break;
    case 'agreementTemplateApi':
    case 'emailTemplateApi':
      labelText = 'Create Template';
      break;
    case 'pageComponent':
      break;
    case 'refreshPageComponent':
      break;
    case 'showPageComponents':
    case 'hidePageComponents':
      break;
    case 'modalApi':
      break;
    case 'dsRestApi':
    case 'dsDatabase':
    case 'dsGoogleSheet':
    case 'dsAirtable':
    case 'dsFirebaseCloudFirestore':
    case 'dsFirebaseFunction':
    case 'dsFirebaseRealtimeDatabase':
      labelText = 'Create Data Source';
      break;
    case 'dsExternalApi':
      labelText = 'Create External API';
      break;
    case 'collectionApi':
      labelText = 'Create Collection';
      break;
    case 'collectionRequestApi':
      break;
  }
  return labelText;
};

export const getFieldDescriptionText = (args, action) => {
  let labelText = '';
  switch (args.optionsType) {
    case 'pageApi':
      if (action.name === 'logoutUser')
        labelText = 'Select a page you want users to land after logout.';
      else if (action.name === 'goToPage') labelText = 'Select the page you want users to land on.';
      else if (action.name === 'switchUserTenant')
        labelText = 'Select the page you want user to land on after switching the tenant.';
      else if (
        [
          'generateEmailOTP',
          'generateSmsOTP',
          'generateUserConsentEmailOTP',
          'generateUserConsentSmsOTP',
        ].includes(action.name)
      ) {
        labelText = 'Select the page you want users to land for verifying the OTP.';
      } else if (action.name === 'showConfirmationMessage') {
        labelText = 'Select a page you want user to land after canceling the confirmation message.';
      } else if (['verifyUserConsentEmailOTP', 'verifyUserConsentSmsOTP'].includes(action.name)) {
        if (args.name === 'successRedirectUrl') {
          labelText = 'Select a page you want users to land after verifying the OTP.';
        } else if (args.name === 'errorRedirectUrl') {
          labelText = 'Select a page you want users to land after failing to verify the OTP.';
        }
      } else labelText = 'Select a page you want users to land after signing up.';
      break;
    case 'refreshPageApi':
      if (action.name === 'sendResetPasswordEmail')
        labelText = 'Select a page where you have added the password reset email form.';
      if (action.name === 'sendEmail') labelText = 'Select a page where you have added form.';
      if (action.name === 'resetNewPassword')
        labelText = 'Select a page where you have added the password reset form.';
      if (action.name === 'refreshSection')
        labelText = 'Select a page that contains the element on which you want to apply the event.';
      break;
    case 'showComponentPageApi':
      labelText = 'Select a page that contains the element on which you want to apply the event.';
      break;
    case 'hideComponentPageApi':
      labelText = 'Select a page that contains the element on which you want to apply the event.';
      break;
    case 'userRoleApi':
      if (action && action.name && action.name === 'addUserToTenant') {
        labelText =
          "Select a user role you want to assign to new user (if given user doesn't exist).";
      } else {
        labelText = 'Select a sign up user role, previously created.';
      }
      break;
    case 'agreementTemplateApi':
    case 'emailTemplateApi':
    case 'smsTemplateApi':
      labelText = 'Select a template you want to send via this event.';
      break;
    case 'resetPassowordPageComponent':
      if (action.name === 'sendResetPasswordEmail')
        labelText = 'Select the password reset email form.';
      if (action.name === 'resetNewPassword') labelText = 'Select the password reset  form.';
      if (action.name === 'sendEmail') labelText = 'Select the form which have email field.';
      break;
    case 'pageComponent':
      if (action.name === 'sendResetPasswordEmail' || action.name === 'sendEmail')
        labelText = 'Select the email address input field.';
      if (action.name === 'resetNewPassword' && args.name === 'confirmPassword')
        labelText = 'Select the confirm password input field.';
      if (action.name === 'resetNewPassword' && args.name === 'password')
        labelText = 'Select the  password input field.';
      break;
    case 'refreshPageComponent':
    case 'showPageComponents':
    case 'hidePageComponents':
      labelText = 'Select the page component on which you want to apply the event.';
      break;
    case 'pageFormComponents':
      labelText = 'Select the form component on which you want to apply the event.';
      break;
    case 'modalApi':
      labelText = 'Select a modal (from Snippets) that you want to show using this event.';
      break;
    case 'dsRestApi':
      labelText = 'Select a REST API data source that previously you’ve created.';
      break;
    case 'dsDatabase':
      labelText = 'Select a Database data source that previously you’ve created.';
      break;
    case 'dsGoogleSheet':
      labelText = 'Select a Google Sheet data source that previously you’ve created.';
      break;
    case 'dsAirtable':
      labelText = 'Select an Airtable data source that previously you’ve created.';
      break;
    case 'dsFirebaseCloudFirestore':
      labelText = 'Select a Firebase Realtime Database data source that previously you’ve created.';
      break;
    case 'dsFirebaseFunction':
      labelText = 'Select a Firebase Function data source that previously you’ve created.';
      break;
    case 'dsFirebaseRealtimeDatabase':
      labelText = 'Select a Firebase Cloud Firestore data that previously you’ve created.';
      break;
    case 'dsExternalApi':
      labelText = 'Select a External API that previously you’ve created.';
      break;
    case 'collectionApi':
      if (
        action.name === 'dependentDropDownPopulateOnChange' ||
        action.name === 'pdfToText' ||
        action.name === 'amazonTextract' ||
        action.name === 'customTermsAnonymization' ||
        action.name === 'nlpAnonymization'
      )
        labelText = 'Select a collection from which you want to get data.';
      if (action.name === 'saveCollectionAssets')
        labelText = 'Select a collection in which you want to store the Assets';
      if (action.name === 'updateCollectionAssets')
        labelText = 'Select a collection in which you want to update the Assets';
      if (['generatePdfFromSnippet', 'generatePdfFromSection'].includes(action.name))
        labelText = 'Select a collection in which you want to store the PDF.';
      if (
        [
          'verifyUserConsentEmailOTP',
          'generateUserConsentEmailOTP',
          'generateUserConsentSmsOTP',
          'verifyUserConsentSmsOTP',
        ].includes(action.name)
      )
        labelText = 'Select a collection in which you want to save the data.';
      else if (['saveItemInMetaDataTable', 'mapAllDataInMetaDataTable'].includes(action.name)) {
        labelText =
          args.name === 'metaDataCollection'
            ? 'Select Meta Data Collection in which you want to save the data.'
            : 'Select Target Collection of which you want to map the data.';
      } else if (action.name === 'updateItemInMetaDataTable') {
        labelText =
          args.name === 'metaDataCollection'
            ? 'Select Meta Data Collection in which you want to update the data.'
            : 'Select Target Collection of which you want to map the data.';
      } else if (action.name === 'deleteItemInMetaDataTable') {
        labelText =
          args.name === 'metaDataCollection'
            ? 'Select Meta Data Collection from which you want to delete the data.'
            : 'Select Target Collection of which you want to map the data.';
      } else labelText = 'Select a collection from which you want to delete data.';
      break;
    case 'collectionRequestApi':
      labelText = 'Select the type of users to whom you allow adding new data to a collection.';
      break;
    case 'provider':
      labelText = 'Select a provider you want users to use to login/sign up';
      break;
    case 'refreshPageComponentPosition':
      labelText =
        'Choose whether you want new data entry to appear at the beginning or bottom after section refreshes';
      break;
    case 'waitTimeOptionsInSecond':
      labelText = 'Wait time before call reload data.';
      break;
    case 'multiTenantApi':
      if (action.name === 'addUserToTenant') {
        labelText = 'Select the Tenant in which you want to add a user.';
      } else if (action.name === 'removeUserFromTenant') {
        labelText = 'Select the Tenant from where you want to remove a user.';
      }
      break;
    case 'otpAuthenticationType':
      labelText = 'Select the authentication type you want.';
      break;
    case 'dataOperationType':
      labelText = 'Select the operation type you want to perform.';
      break;
    case 'collectionFieldApi':
      if (action.name === 'generateUserConsentEmailOTP') {
        labelText = `Select the user's email field to send the OTP for user consent verification.`;
      } else if (action.name === 'generateUserConsentSmsOTP') {
        labelText = `Select the user's phone number field to send the OTP for user consent verification.`;
      }
      break;
    case 'emailServicePluginApi':
      labelText = 'Select the service from which you want to send the email.';
      break;
    case GET_ITEM_ID_FROM_API:
      labelText = 'Select Item id of the Modal/Subpage Item.';
      break;
  }
  return labelText;
};

export const getFieldDescriptionTextByName = (args, action) => {
  let labelText = '';
  switch (args.name) {
    case 'enableResetForm':
      labelText =
        'Disabled (by default) to reset parent form component. Enable it to target the specific form component.';
      break;
    case 'enableSubmitForm':
      labelText =
        'Disabled (by default) to submit parent form component. Enable it to target the specific form component.';
      break;
    case 'overrideResetWaitTime':
      labelText = '(Optional) Wait before resetting a form on page load. (Default: 500 ms)';
      break;
    case 'overrideSubmitWaitTime':
      labelText = '(Optional) Wait before submitting a form on page load. (Default: 500 ms)';
      break;
    case 'confirmationMessage':
      labelText = '(Optional) A custom confirmation alert message to display on a popup.';
      break;
    case 'confirmBtnText':
      labelText = '(Optional) A custom confirm button text. (Default: Proceed)';
      break;
    case 'cancelBtnText':
      labelText = '(Optional) A custom cancel button text. (Default: Cancel)';
      break;
    case 'clearAllResponseData':
      labelText = 'Enable to clear values from the session: previousActionResponse';
      break;
    case 'clearAllFormData':
      labelText = 'Enable to clear values from the session: previousActionFormData';
      break;
    case 'clearResponseSelectedKeys':
      labelText =
        'Add single or, multiple comma (,) separated response keys to clear from the session: previousActionResponse';
      break;
    case 'clearFormSelectedKeys':
      labelText =
        'Add single or, multiple comma (,) separated form data keys to clear from the session: previousActionFormData';
      break;
    case 'successMessage':
      labelText = '(Optional) Enter custom success message.';
      break;
    case 'errorMessage':
      labelText = '(Optional) Enter custom error message.';
      break;
    case 'customSessionKey':
      labelText =
        'A custom JSON key which will store the data in your web browser session storage. (Default: collection_[Collection_Name]';
      break;
    default:
      break;
  }
  return labelText;
};

export const getFieldDescriptionInfoByName = (args, action) => {
  let description = '';
  switch (args.name) {
    case 'sendCurrentObjectID':
      description =
        'Enable it to send the recently created or updated Collection Item ID to the next page.';
      break;
    case 'sendPreviousStepParentCollectionId':
      description =
        "Enable it to send the Collection's Item ID, which was recorded in the previous step, to the next page.";
      break;
    case 'sendCurrentUserId':
      description = 'Enable it to send the Current LoggedIn User ID, to the next page.';
      break;
    case 'isNewTab':
      description = 'Enable it to open the navigated page in the new tab of the browser. ';
      break;
    case 'sendCurrentPageItemId':
      description =
        "Enable it to send the Collection's Item ID from the Current Page URL, to the next page.";
      break;
    case 'skipPageReload':
      description = 'Enable it to skip reloading a page (Default: Page will reload on success).';
      break;
    case 'tenantRoleRedirectionRule':
      description = 'Select the page you want user to land on after switching the tenant.';
      break;
    case 'sendCurrentPageReferenceItemId':
      description = `Enable it to send the Collection's Item ID of Current Page Reference Item`;
      break;
    case 'sendTargetItemID':
      description =
        'Enable it to send the target element (Link/Button) Collection Item ID to the next page.';
      break;
    case 'sendItemIdFrom':
      description = `Select the location from where the Item ID should be used to send to the next page.`;
      break;
    default:
      break;
  }
  return description ? (
    <TooltipInfo
      title={description}
      headerText={`What's ${args.label}?`}
      showHeader={true}
      showArrow={true}
    />
  ) : (
    ''
  );
};

export const getActiveTab = (optionsType) => {
  switch (optionsType) {
    case DS_REST_API:
      return REST_API;
    case DS_AIRTABLE:
      return AIRTABLE;
    case DS_DATABASE:
      return DATABASE;
    case DS_GOOGLE_SHEET:
      return GOOGLE_SHEET;
    case DS_FIREBASE_CLOUD_FIRESTOE:
      return FIREBASE_CLOUD_FIRESTORE;
    case DS_FIREBASE_FUNCTION:
      return FIREBASE_FUNCTION;
    case DS_FIREBASE_REALTIME_DATABASE:
      return FIREBASE_REALTIME_DATABASE;
  }
};

export const validateSubmitBtn = (values, eventAction) => {
  let isSubmitBtnDisabled = false;
  let hasAllRequiredValues = false;
  let requiredFieldList = [];

  switch (eventAction.name) {
    case 'goToPage':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('destination');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    case 'showModal':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('modal');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    case 'customPageRedirect':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('redirectValueFrom', 'destination');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    case 'system_show_component':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('showComponentPage', 'showComponents');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    case 'system_hide_component':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('hideComponentPage', 'hideComponents');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    case 'deleteCollectionItem':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('collection');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    case 'saveCollection':
    case 'saveCollectionDraft':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('collection');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    default:
      break;
  }
  return isSubmitBtnDisabled;
};

export const getActionEnableSchema = (events, eventAction) => {
  const { project } = events ? events : '';
  console.log('🚀 ~ file: ActionFormUtils.js:324 ~ getActionEnableSchema ~ project:', project);
  const { environments } = project ? project : '';
  const { defaultEnabled, enabledEnvironments } = eventAction ? eventAction : '';
  console.log(
    '🚀 ~ file: ActionEnableForm.js:21 ~ ActionEnableForm ~ defaultEnabled:',
    defaultEnabled,
    ' ~ enabledEnvironments:',
    enabledEnvironments,
  );

  let schema = {};
  if (!defaultEnabled) {
    environments.map((environment) => {
      schema[environment.envType] = !!(
        enabledEnvironments &&
        enabledEnvironments.length &&
        enabledEnvironments.includes(environment.envType)
      );
    });
  } else if (environments && environments.length) {
    environments.map((environment) => {
      schema[environment.envType] = true;
    });
  }
  console.log('🚀 ~ file: ActionFormUtils.js:40 ~ getActionEnableSchema ~ schema:', schema);
  return schema;
};

export const getSnippetModalOptions = (snippets) => {
  let modalOptions = [];

  if (!snippets || !snippets.length) {
    return modalOptions;
  }

  const modalSnippet = snippets.filter((snippet) => snippet.snippetType === 'MODAL');

  modalSnippet.forEach((snippet) => {
    const pageComponent =
      snippet.content && snippet.content['nocode-components']
        ? JSON.parse(snippet.content['nocode-components'])
        : '';
    const modalComponent = pageComponent.find((comp) => comp.type === 'modal');

    if (modalComponent) {
      modalOptions.push({
        value: modalComponent.attributes['id'] + CUSTOM_MODAL_SEPARATOR + snippet.uuid,
        label: snippet.name,
      });
    }
  });
  return modalOptions;
};
